<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="input-group input-group-sm" style="width: 250px;">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">Export
                <i class="fas fa-download"></i>
              </button>
            </div>
          </div>

        </div>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 300px;">
            <input type="text" name="table_search" [(ngModel)]="searchString" class="form-control float-right"
              placeholder="Search">

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-search"></i>
              </button>
            </div>

            <select type="text" name="table_search" [(ngModel)]="sortby" class="form-control float-right">
              <option value="id">Plt No</option>
              <!-- <option value="area">Area</option> -->
              <option value="date">Date</option>
            </select>

            <div class="input-group-append">
              <button type="submit" class="btn btn-default">
                <i class="fas fa-sort"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive p-0" style="height: 410px;">
        <table class="table table-head-fixed text-nowrap">
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Property ID</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Mode</th>
              <th>Ref. no.</th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngIf="!isloading">
            <tr *ngFor="let payment of payments | filter: searchString: 'status' | sort: [ sortby,''] ">
              <td>{{ payment.customer.name }}</td>
              <td>{{ payment.customer.pid }}</td>
              <td>{{payment.amount}}</td>
              <td>{{ payment.date | date:'dd-MM-yyyy' }}</td>
              <td>{{ payment.mode }}</td>
              <td>{{ payment.ref_number }}</td>
              <td>
                <a class="btn" (click)="info(payment.id)"><i class="fas fa-info"></i></a>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="isloading">
            <td class="text-center" colspan="7"> loading ...</td>
          </tbody>
        </table>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </div>
</div>
